import Modal from './Modal';
export default class RequestErrorModal extends Modal {
  className() {
    return 'RequestErrorModal Modal--large';
  }
  title() {
    return !!this.attrs.error.xhr && `${this.attrs.error.xhr.status} ${this.attrs.error.xhr.statusText}`;
  }
  content() {
    const {
      error,
      formattedError
    } = this.attrs;
    let responseText;

    // If the error is already formatted, just add line endings;
    // else try to parse it as JSON and stringify it with indentation
    if (formattedError.length) {
      responseText = formattedError.join('\n\n');
    } else if (error.response) {
      responseText = JSON.stringify(error.response, null, 2);
    } else {
      responseText = error.responseText;
    }
    if (responseText?.includes('<script> Sfdump = window.Sfdump')) {
      responseText = m("iframe", {
        srcdoc: responseText,
        className: "RequestErrorModal-iframe",
        onload: e => {
          const iframe = e.target;
          iframe.style.height = (iframe.contentWindow?.document.body.offsetHeight || 0) + 50 + 'px';
        }
      });
    }
    return m("div", {
      className: "Modal-body"
    }, m("pre", null, this.attrs.error.options.method, " ", this.attrs.error.options.url, m("br", null), m("br", null), responseText));
  }
}
flarum.reg.add('core', 'common/components/RequestErrorModal', RequestErrorModal);